import PolicyLayout from '../../components/PolicyLayout';
import { Mail, MapPin, Clock } from 'lucide-react';

export default function ContactPage() {
  return (
    <PolicyLayout title="Contact Us" lastUpdated="February 2026">
      <section className="mb-8">
        <p className="text-slate-400 text-lg">
          We're here to help! If you have any questions, concerns, or feedback about StatioPrint,
          please don't hesitate to reach out.
        </p>
      </section>

      <section className="mb-8">
        <div className="grid gap-6 sm:grid-cols-2">
          <div className="p-6 rounded-xl border border-slate-800 bg-slate-900/50">
            <div className="flex items-center gap-3 mb-4">
              <div className="w-10 h-10 rounded-lg bg-indigo-900/50 flex items-center justify-center">
                <Mail className="text-indigo-400" size={20} />
              </div>
              <h3 className="font-semibold">Email</h3>
            </div>
            <a href="mailto:info@statiomart.com" className="text-indigo-400 hover:underline">
              info@statiomart.com
            </a>
            <p className="text-sm text-slate-500 mt-2">We typically respond within 24 hours</p>
          </div>

          <div className="p-6 rounded-xl border border-slate-800 bg-slate-900/50">
            <div className="flex items-center gap-3 mb-4">
              <div className="w-10 h-10 rounded-lg bg-indigo-900/50 flex items-center justify-center">
                <Clock className="text-indigo-400" size={20} />
              </div>
              <h3 className="font-semibold">Support Hours</h3>
            </div>
            <p className="text-slate-400">Monday - Saturday</p>
            <p className="text-slate-400">9:00 AM - 6:00 PM IST</p>
          </div>
        </div>
      </section>

      <section className="mb-8">
        <h2 className="text-xl font-semibold mb-4">Business Information</h2>
        <div className="p-6 rounded-xl border border-slate-800 bg-slate-900/50">
          <div className="flex items-start gap-3">
            <div className="w-10 h-10 rounded-lg bg-indigo-900/50 flex items-center justify-center flex-shrink-0">
              <MapPin className="text-indigo-400" size={20} />
            </div>
            <div>
              <h3 className="font-semibold mb-2">StatioMart</h3>
              <p className="text-slate-400">StatioPrint is a service by StatioMart</p>
              <p className="text-slate-400 mt-2">
                Website:{' '}
                <a href="https://www.statiomart.com" className="text-indigo-400 hover:underline">
                  www.statiomart.com
                </a>
              </p>
            </div>
          </div>
        </div>
      </section>

      <section className="mb-8">
        <h2 className="text-xl font-semibold mb-4">Common Inquiries</h2>
        <div className="space-y-4">
          <div className="p-4 rounded-lg border border-slate-800">
            <h3 className="font-medium mb-2">Payment Issues</h3>
            <p className="text-sm text-slate-400">
              For payment-related queries, refunds, or transaction issues, please include your
              transaction ID in your email.
            </p>
          </div>
          <div className="p-4 rounded-lg border border-slate-800">
            <h3 className="font-medium mb-2">Print Quality Concerns</h3>
            <p className="text-sm text-slate-400">
              If you experienced print quality issues, please contact the shop directly or email us
              with photos of the issue.
            </p>
          </div>
          <div className="p-4 rounded-lg border border-slate-800">
            <h3 className="font-medium mb-2">Partner With Us</h3>
            <p className="text-sm text-slate-400">
              Own a print shop? Interested in partnering with StatioPrint? Email us to learn more
              about becoming a partner shop.
            </p>
          </div>
        </div>
      </section>

      <section>
        <h2 className="text-xl font-semibold mb-4">Feedback</h2>
        <p className="text-slate-400">
          We value your feedback! Help us improve StatioPrint by sharing your experience and
          suggestions at{' '}
          <a href="mailto:info@statiomart.com" className="text-indigo-400 hover:underline">
            info@statiomart.com
          </a>
        </p>
      </section>
    </PolicyLayout>
  );
}
